// SPDX-License-Identifier: AGPL-3.0-or-later

// LOCAL-ONLY: a bookmark's note changed on another of the user's sessions (favorites-bookmarks-plan.md section 2.3).
// Unused for now (section 10): the server sends no such event, since production's gateway refuses fork events; notes
// reload on open and focus instead (BookmarkNoteReload.ts). Kept registered for a fork gateway. Exclude from upstream
// sync.

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import BookmarkNotes from '@app/features/messaging/state/BookmarkNotes';

interface SavedMessageNoteUpdatePayload {
	message_id: string;
	note: string;
}

export function handleSavedMessageNoteUpdate(
	data: SavedMessageNoteUpdatePayload,
	_context: GatewayHandlerContext,
): void {
	BookmarkNotes.set(data.message_id, data.note);
}
